/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filternormalize1Inputs */

const en_filternormalize1 = /** @type {(inputs: Filternormalize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto levels`)
};

const de_filternormalize1 = /** @type {(inputs: Filternormalize1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-Korrektur`)
};

/**
* | output |
* | --- |
* | "Auto levels" |
*
* @param {Filternormalize1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const filternormalize1 = /** @type {((inputs?: Filternormalize1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filternormalize1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filternormalize1(inputs)
	return de_filternormalize1(inputs)
});
export { filternormalize1 as "filterNormalize" }